import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import AuthService from '../utils/AuthService.js';
import AppointmentService from '../utils/AppointmentService.js';
import CreateAccount from './CreateAccount.js';
import { Switch, Route, Link } from 'react-router-dom'
var parser = require('parse-address');

// if (!window.Promise) {
//   window.Promise = Promise;
// }
class LocationForm extends Component {

  constructor(props) {
    super(props);

    this.Auth = new AuthService()
    this.Appt = new AppointmentService()

    this.state = {
      display_title: '',
      zipcode: '',
      street: '',
      street_adl: '',
      state: '',
      city: '',
      company: '',
      display_title: '',
      notes: '',
      formError: null
    };
    if(props.address && props.address.length > 0){
      var parsed = parser.parseLocation(props.address);
      if(parsed){
        this.state = {
          display_title: this.state.display_title,
          zipcode: typeof parsed.zip == 'undefined' ? "" : parsed.zip,
          street: (typeof parsed.number == 'undefined'||typeof parsed.street  == 'undefined' || typeof parsed.type == 'undefined') ? "" : parsed.number + ' ' + parsed.street + ' ' + parsed.type,
          state: parsed.state,
          city: parsed.city
        }
      }
    }
  }
  componentWillReceiveProps(props){
    if(props.address && props.address.length > 0){
      var parsed = parser.parseLocation(props.address);
      if(parsed){
        this.state = {
          display_title: this.state.display_title,
          zipcode: typeof parsed.zip == 'undefined' ? "" : parsed.zip,
          street: (typeof parsed.number == 'undefined'||typeof parsed.street  == 'undefined' || typeof parsed.type == 'undefined') ? "" : parsed.number + ' ' + parsed.street + ' ' + parsed.type,
          state: parsed.state,
          city: parsed.city
        }
      }
    }
  }
  parseProps(props){

  }
  validateForm(){
    return this.state.email.length > 0 && this.state.password.length > 0;
  }
  handleChange = event => {
      this.setState({
        [event.target.id]: event.target.value
      });
  }
  handleSubmit = event =>  {
    event.preventDefault()
    if(!this.state.display_title){
      this.setState({
        formError: "Please enter a display name for the address"
      })
    }
    else if (!this.state.street) {
      this.setState({
        formError: "Please enter a street address"
      })
    }
    else if (!this.state.city) {
      this.setState({
        formError: "Please enter a City"
      })
    }
    else if (!this.state.state) {
      this.setState({
        formError: "Please enter a state"
      })
    }
    else if (!this.state.zipcode) {
      this.setState({
        formError: "Please enter a zipcode"
      })
    }
    else{
      this.setState({
        formError: ""
      })
      if(this.props.locationId){
        this.Appt.updateAddress(this.props.locationId, this.state.display_title, this.state.street, this.state.city, this.state.state_abbr, this.state.zipcode, this.state.street_adtl, false)
               .then(res =>{
                 if(res){
                   if(res.errors)
                   {
                     this.props.setError(res.errors)
                   }
                   else {
                     this.props.selectLocation(res.address)
                   }
                 }
                 else {
                   this.props.setError("Your address was invalid")
                 }
               })
               .catch(err =>{
                 console.log("err", err)
                //  this.props.setError("Your address was invalid")
               })
      }
      else {
        this.Appt.saveNewAddress(this.state.street, this.state.city, this.state.city, this.state.zipcode, this.state.display_title)
               .then(res =>{
                 if(res){
                   this.props.selectLocation(res.address)
                 }
                 else {
                   this.props.setError("Your address was invalid")
                 }
               })
               .catch(err =>{
                  this.props.setError("Your address was invalid")
               })
             }
      this.props.closeModal()
    }
  }

    render(){
      return (
              <div className='addressForm'>
                <p className="redText">{this.state.formError}</p>
                <form onSubmit={this.handleSubmit}>
                  <div className="form-group ">
                    <input className="form-control" type="text" id="display_title" value={this.state.display_title} onChange={this.handleChange} placeholder="Location Name" ></input>
                  </div>
                  <div className="form-group">
                    <input className="form-control" type="text" id="street" value={this.state.street} onChange={this.handleChange} placeholder="Street"></input>
                  </div>
                  <div className="form-row mb-3">
                    <div className="col">
                      <input className="form-control form-control-md" type="text" id="address_2" onChange={this.handleChange} placeholder="Address 2"></input>
                    </div>
                    <div className="col">
                      <input className="form-control form-control-md" type="text" id="city" value={this.state.city} onChange={this.handleChange} placeholder="City"></input>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col">
                      <input className="form-control form-control-md" type="text" id="state" value={this.state.state} onChange={this.handleChange} placeholder="State"></input>
                    </div>
                    <div className="col">
                      <input className="form-control form-control-md" type="text" id="zipcode" value={this.state.zipcode} onChange={this.handleChange} placeholder="Zip"></input>
                    </div>

                  </div>
                  <div className="form-group">
                    <button className="btn btn-success margin-top btn-block text-center" type="submit">Confirm Address</button>
                  </div>
                </form>
              </div>
              )
    }
}
export default LocationForm;



// WEBPACK FOOTER //
// ./src/Components/LocationForm.js